import React, { useEffect, useState } from 'react';

/**
 * To check whethere the screen is web view or mobile view.
 */
export const IsWeb = () => {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    setWidth(window.innerWidth);
  }, [window.innerWidth]);

  return width > 992 ? true : false;
};
